module.exports = __webpack_public_path__ + "img/bmpcimg2.3638c544.png";